export const moduleIds = {
  item: 2,
  customer: 4,
  quotation: 5,
  salesOrder: 6,
  invoice: 7,
  vendor: 8,
  purchaseInvoice: 10,
} as const;
